import { Box, Button, Slider, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import { UserContext } from '../../Context/UserContext/UserContextProvider';
import { LoggingContext } from '../../Context/LoggingContext/LoggingContext';
import { teesPropertiesObject } from '../../tools/generalProperties';
import {
  AllTShirtMeasuresMandatory,
  TeeMeasureLabel,
} from '../../types/databaseTables/idealteemeasures';

interface WeightMeasureSliderProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<AllTShirtMeasuresMandatory>>;
  sliderLabel: TeeMeasureLabel;
}

export function WeightMeasureSlider({ value, setValue, sliderLabel }: WeightMeasureSliderProps) {
  const [localValue, setLocalValue] = useState(value);
  const { addLog } = useContext(LoggingContext);
  const location = useLocation();

  // Debounce update to filterState from local checked state
  React.useEffect(() => {
    function updateWhenSliderMoved() {
      if (value === localValue) {
        return;
      }
      setValue((prev) => ({ ...prev, [sliderLabel]: localValue }));
    }
    const delayDebounceFn = setTimeout(() => {
      updateWhenSliderMoved();
    }, 100);
    return () => clearTimeout(delayDebounceFn);
  }, [localValue]);

  return (
    <Box sx={{ width: '300px', margin: 'auto' }}>
      <Typography id='input-slider' gutterBottom>
        {teesPropertiesObject[sliderLabel].name}
      </Typography>
      <Slider
        onClick={() => addLog('weight measure slider clicked', location.pathname)}
        aria-label='measure weight'
        defaultValue={value}
        valueLabelDisplay='auto'
        step={1}
        marks
        min={0}
        max={5}
        onChange={(event: Event, newValue: number | number[]) => {
          setLocalValue(newValue as number);
        }}
      />
    </Box>
  );
}

function WeightMeasuresSettings() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const { addLog } = useContext(LoggingContext);
  const { userDetailsState, dispatchUserDetailsState } = useContext(UserContext);
  const [localWeightingsState, setLocalWeightingsState] = useState(
    userDetailsState.fitScoreWeightings
  );
  return (
    <Box sx={{ margin: '32px 32px' }}>
      <Box sx={{ justifyContent: 'center', display: 'flex', marginBottom: '32px' }}>
        <Button
          variant='contained'
          color='secondary'
          onClick={() => {
            dispatchUserDetailsState({
              type: 'update measure weightings',
              payload: { fitScoreWeightings: localWeightingsState },
            });
            addLog('clicked SAVE WEIGHTINGS button', location.pathname);
            enqueueSnackbar(`Updated measure Weightings`, { variant: 'success' });
          }}
        >
          Save Weightings
        </Button>
      </Box>
      <Box sx={{ margin: 'auto' }}>
        {Object.keys(localWeightingsState).map((thisMeasureLabel) => (
          <WeightMeasureSlider
            value={localWeightingsState[thisMeasureLabel as TeeMeasureLabel] || 0}
            setValue={setLocalWeightingsState}
            sliderLabel={thisMeasureLabel as TeeMeasureLabel}
            key={thisMeasureLabel}
          />
        ))}
      </Box>
    </Box>
  );
}

export default WeightMeasuresSettings;
